import SecureRoute from "./SecureRoute";

export default SecureRoute;
